import { ENVIRONMENT } from './../config/config';
import { getCookieValue } from 'shared';

export const getAuthToken = () => {
  return getCookieValue(`${ENVIRONMENT}_yepic_access_token`);
};
